<template>
    <div>
        <div
            class="tooltip-vue relative"
            :class="{ 'p-3': type === 'text', 'p-1': type === 'image' }"
        >
            <div class="flex justify-center text-xs leading-5">
                <slot />
            </div>
            <div class="tooltip-triangle"></div>
        </div>
    </div>
</template>

<script lang="ts" setup>
defineProps({
    type: {
        type: String,
        default: "text",
    },
});
</script>

<style scoped>
.tooltip-vue {
    color: white;
    background-color: rgba(51, 58, 68, 0.9);
    z-index: 1;
    border-radius: 6px;
    box-shadow: 0px 0px 10px rgba(114, 76, 25, 0.05);
}

.tooltip-triangle {
    width: 14px;
    height: 14px;
    background: linear-gradient(
        to bottom right,
        transparent 55%,
        rgba(51, 58, 68, 0.9) 45%
    );
    transform: rotate(45deg);
    position: absolute;
    border-radius: 2px;
    bottom: -6px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
    box-shadow: 0px 0px 10px rgba(114, 76, 25, 0.05);
}
</style>
